import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "Candidature" })
export default class Candidature extends Vue {
    public localizer: any = Localizer;
    public formData: any = {
        eduQualification: null,
        langSpEnglish: null,
        langWrEnglish: null,
        langSpFrench: null,
        langWrFrench: null,
        langSpGerman: null,
        langWrGerman: null,
        langSpOther: null,
        langWrOther: null
    };
    public validationErrors: any[] = [];
    public recaptchaId: number = null;
    public isSubmitting: boolean = false;
    public isSuccess: boolean = false;

    public jobRates: any[] = [];
    public jobQualifications: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly recaptchaSiteKey: string;

    public created() {
        this.getData();
    }

    public mounted() {
        this.setRecapthca();
    }

    public setRecapthca() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async getData() {
        const response = (await Axios.get(this.routes.Company_GetCandidatureData)).data;
        this.jobRates = response.jobRates;
        this.jobQualifications = response.jobQualifications;
    }

    public async submitForm() {
        this.validationErrors = [];
        this.isSubmitting = true;

        this.recaptchaId = this.getWidgetId("RecaptchaCandidature");

        let multipartData = new FormData();

        const inputFile = document.getElementById("InputFile") as any;

        if (inputFile && inputFile.files && inputFile.files.length > 0) {
            const file = inputFile.files[0];

            const fileSizeInMB = file.size / 1024 / 1024;
            if (fileSizeInMB > 4) {
                this.isSubmitting = false;
                this.validationErrors.push({ Name: "InputFile", Errors: ["Il file deve essere inferiore a 4 MB."] });
                return;
            }

            multipartData.append("InputFile", file);
        }

        for (const key in this.formData) {
            if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
                multipartData.append(key, this.formData[key]);
            }
        }

        try {
            await Axios.post(this.routes.Company_CandidatureSave, multipartData, { headers: { "Content-Type": "multipart/form-data", "RequestVerificationToken": FormHelper.getRequestVerificationToken(), "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse(this.recaptchaId) } });
            this.isSuccess = true;
            document.getElementById("CandidatureTitle").classList.add("hden");

        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        (<any>window).grecaptcha.reset(this.recaptchaId);

        this.isSubmitting = false;
    }

    public getWidgetId(elementId: string): number {
        const recaptchaBoxes = document.querySelectorAll('.g-recaptcha');
        const targetBox = document.querySelector(`#${elementId}`);

        for (let i = 0; i < recaptchaBoxes.length; i++) {
            if (recaptchaBoxes[i].id === targetBox.id) {
                return i;
            }
        }
        return 0;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
}
